import qualificationApi from '@/api/pumba/qualificationApi';
import developerApi from '@/api/app-store/developerApi';
import store from '../index';

export const state = {
    loading: false,
    storesTestCount: null,
};

export const getters = {
    loading: (states) => states.loading,
};

export const mutations = {
    SET_LOADING(state, payload) {
        state.loading = payload;
    },
    SET_COUNT_ENV(state, count) {
        state.storesTestCount = count;
    },
};

export const actions = {
    async enableProfile({ commit }) {
        commit('SET_LOADING', true);

        try {
            const response = await qualificationApi.setDeveloper();

            if (response.status === 200) {
                await store.dispatch('auth/fetchUser');
            }
        } catch (error) {
            console.error('Error on qualify developer profile.', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },
    async fetchTestStoresCount({ commit, state }) {
        if (!state.envTestCount || state.envTestCount < 0) {
            const data = await developerApi.getEnvironments();

            commit('SET_COUNT_ENV', data.length);
        }
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
